import InnoIcons from "@InnoIcons/";
import { format } from "date-fns";
import moment from "moment";
import { extractZipFiles, showAlert } from "utils/helper";

export const innoTableConfig = {
  pageSize: 20,
};
export const innoTableConfigsecond = {
  pageSize: 20,
};

export const InnoTableDefaultPageSize = {
  pageSize: 100,
};

export const validatePassword = (password) => {
  const minLength = password.length >= 8;
  const hasUppercase = /[A-Z]/.test(password);
  const hasLowercase = /[a-z]/.test(password);
  const hasNumber = /\d/.test(password);
  const hasSpecialChar = /[@$!%*?&#><]/.test(password);

  // Check if all conditions are met
  if (
    minLength &&
    hasUppercase &&
    hasLowercase &&
    hasNumber &&
    hasSpecialChar
  ) {
    return { isValid: true, message: "" };
  }

  // Build a message based on unmet conditions
  const messages = [];
  if (!minLength) messages.push("at least 8 characters");
  if (!hasUppercase) messages.push("an uppercase letter");
  if (!hasLowercase) messages.push("a lowercase letter");
  if (!hasNumber) messages.push("a number");
  if (!hasSpecialChar) messages.push("a special character");

  return {
    isValid: false,
    message: `New password must contain ${messages.join(", ")}.`,
  };
};

// Function to validate userName
export const validateUserName = (value, length = 0) => {
  const isValidUserName = /^(?=.*[a-zA-Z])(?!^\d+$)[a-zA-Z0-9.@_]+$/.test(
    value,
  );
  if (isValidUserName && value.length < length) {
    return false;
  }
  return isValidUserName;
};

// emailValidator.js
export const validateEmail = (email) => {
  // Email regex pattern
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
export const validateEmail2 = (email) => {
  const emailRegex = /^[\w._]+@[\w._]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

export const validtionMessages = {
  username:
    "Please ensure your username contains at least 5 letter, can include numbers, and allowed special characters are . @ _ ",
  email: "Please enter a valid email address",
};

export function formatDateTime(
  dateString,
  locale = "en-US",
  options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    timeZone: "UTC", // Ensure we use UTC
  },
) {
  return new Date(dateString).toLocaleString(locale, options);
}

export function formatDatestring(
  dateString,
  locale = "en-US",
  options = {
    year: "numeric",
    month: "long",
    day: "numeric", // Ensure we use UTC
  },
) {
  return new Date(dateString).toLocaleString(locale, options);
}

export const convertBase64 = (file, maxSize) => {
  return new Promise((resolve, reject) => {
    if (file) {
      // Validate file size
      if (file.size > maxSize) {
        showAlert({
          title: "Warning",
          text: `File size exceeds ${(maxSize / 1024 / 1024).toFixed(
            2,
          )} MB. Please choose a smaller image.`,
          icon: "warning",
        });

        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        resolve({
          name: file.name,
          preview: reader.result,
        });
      };
      reader.onerror = (error) => {
        reject("Error reading the file");
      };
      reader.readAsDataURL(file);
    }
  });
};

export const convertToDDMMYYYY = (date) => {
  if (!date) return "";

  const parsedDate = new Date(date);
  return !isNaN(parsedDate.getTime())
    ? parsedDate.toISOString().split("T")[0]
    : "";
};

export const convert = (value, unit) => {
  if (unit === "m²") {
    return value * 0.092903;
  }
  return value;
};

export const convertMToFT = (value) => {
  return (value * 10.7639).toFixed(3);
};

export const regexPattern = {
  textOnly: "^[a-zA-Z\\s]*$",
  number: "^[0-9]*$",
  numberWithDecimal: "^[0-9]*(.[0-9]+)?$",
  email: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$",
  textWithNumber: "^(?!.*[.\\s-\\s/]{2})[a-zA-Z0-9\\s.-/]*$",
  textNumberSumbole: "^(?!.*[.-/_]{2})[a-zA-Z0-9.\\-/_()& ]*$",
  noSpace: "^[a-zA-Z0-9-]*$",
  oneSpace: "^(?!.*[.\\s]{2})[a-zA-Z0-9\\s\\-\\/]*$",
  forFileName: "^[a-zA-Z0-9 _.,:;@'<>?/()\\-]*$",

  exText: "^[^<>{}%^*`]*$",
  notonlyNumber: "^[^d].*",
  pattern: /^\+?[0-9\s\-\(\)]{7,15}$/,
  emailValid: "/^[w.-]+@([w-]+.)+[w-]{2,4}$/",
  decimaltwo: "^(0|[1-9][0-9]*)(\\.[0-9]{1,2})?$",
};

export const regexTypes = {
  textOnly: "textOnly",
  number: "number",
  numberWithDecimal: "numberWithDecimal",
  email: "email",
  textWithNumber: "textWithNumber",
  noSpace: "noSpace",
  oneSpace: "oneSpace",
  exText: "exText",
  notonlyNumber: "notonlyNumber",
  textNumberSumbole: "textNumberSumbole",
  pattern: "pattern",
  emailValid: "emailValid",
  forFileName: "forFileName",
  decimaltwo: "decimaltwo",
};

export const regexHelpMap = {
  [regexTypes.textOnly]:
    "Allows only letters and spaces. No numbers or special characters.",
  [regexTypes.number]:
    "Allows only digits. No letters, spaces, or special characters.",
  [regexTypes.numberWithDecimal]:
    "Allows digits and an optional decimal point (e.g., 12.34).",
  [regexTypes.email]:
    "Validates standard email format (e.g., user@example.com).",
  [regexTypes.textWithNumber]:
    "Allows letters, numbers, spaces, dot (.), dash (-), and slash (/). Prevents consecutive special characters.",
  [regexTypes.textNumberSumbole]:
    "Allows letters, numbers, dot (.), dash (-), slash (/), underscore (_), parentheses, ampersand (&), and spaces. Prevents consecutive special characters.",
  [regexTypes.noSpace]:
    "Allows letters, numbers, and hyphen (-). No spaces or other special characters.",
  [regexTypes.oneSpace]:
    "Allows letters, numbers, single spaces, dash (-), and slash (/). Prevents consecutive spaces or special characters.",
  [regexTypes.forFileName]:
    "Allows letters, numbers, spaces, and common punctuation (@ ; ' , ' - . <> / ? ( ) / _)",
  [regexTypes.exText]:
    "Blocks special characters like < > { } % ^ * ` for safe text input.",
  [regexTypes.notonlyNumber]:
    "Prevents values starting with a digit only (e.g., ensures not only numbers).",
  [regexTypes.pattern]:
    "Allows optional '+' and phone number characters (digits, space, dash, parentheses), between 7 to 15 characters long.",
  [regexTypes.emailValid]:
    "Validates emails using basic pattern (e.g., user@example.com). Note: Simplified version.",
};

export function htmlToPlainText(html) {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  return tempDiv.textContent || tempDiv.innerText || "";
}

// 50 MB in bytes
export const SUMMARY_MAX_SIZE = 32 * 1024 * 1024;
export const MAX_FILE_SIZE = 50 * 1024 * 1024; // 20MB in Bytes

// allowed MIME types (PDF + Word docs + plain text)
export const SUMMARY_ALLOWED_MIMES = ["application/pdf"];

// fallback extension check for browsers that don't provide accurate mime type
export const SUMMARY_ALLOWED_EXT = [".pdf"];

export const isAllowedForSummary = (file) => {
  if (!process.env.REACT_APP_AI_SERVICE) {
    return false;
  }
  if (!file) return false;
  if (file.size >= SUMMARY_MAX_SIZE) return false;
  if (file.type && SUMMARY_ALLOWED_MIMES.includes(file.type)) return true;
  const name = (file.name || file.fileName || "").toLowerCase();
  return SUMMARY_ALLOWED_EXT.some((ext) => name.endsWith(ext));
};

export const isPdfFile = (f = {}) => {
  if (!f) return false;
  const type = f.type || f.fileType || "";
  if (type === "application/pdf") return true;
  const name = (f.name || f.fileName || "").toLowerCase();
  return name.endsWith(".pdf");
};

export const isZipFile = (fileOrName = {}) => {
  if (!fileOrName) return false;
  const name = (fileOrName.name || fileOrName.fileName || "")
    .toString()
    .toLowerCase();
  const type = fileOrName.type || fileOrName.fileType || "";
  return (
    type === "application/zip" ||
    type === "application/x-zip-compressed" ||
    name.endsWith(".zip")
  );
};

// ----- zip processing: extract and find single PDF -----
// returns { pdfs: [], cleaned: [], error: null }
// each pdf item is { fileName, fileType, fileSize, buffer }
export const extractAndFindPdfs = async (zipFile, isValidFile) => {
  try {
    const extracted = await extractZipFiles(zipFile);
    const cleaned = extracted.filter((f) => isValidFile(f.fileName));
    const pdfs = cleaned.filter((f) => isPdfFile(f));
    return { pdfs, cleaned, error: null };
  } catch (err) {
    return { pdfs: [], cleaned: [], error: err?.message || String(err) };
  }
};

export const isZipPdfAllowedForSummary = (zipInnerPdf) => {
  if (!zipInnerPdf) return false;
  return zipInnerPdf.fileSize <= SUMMARY_MAX_SIZE; // 50MB limit
};

// convert ArrayBuffer / Uint8Array buffers to File object
export const bufferToFile = (
  buffer,
  name = "file.pdf",
  type = "application/pdf",
) => {
  if (!buffer) return null;
  let ab;
  if (buffer instanceof ArrayBuffer) ab = buffer;
  else if (ArrayBuffer.isView(buffer)) ab = buffer.buffer;
  else ab = buffer; // hope it's acceptable
  const blob = new Blob([ab], { type });
  return new File([blob], name, { type });
};

// fetch a presigned url or file url and return File object (respects CORS/presigned urls)
export const fetchUrlToFile = async (url, name = "file") => {
  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`Fetch failed ${res.status}`);
    const blob = await res.blob();
    return new File([blob], name, {
      type: blob.type || "application/octet-stream",
    });
  } catch (err) {
    console.warn("fetchUrlToFile error:", err);
    return null;
  }
};

export const stripKnownExtension = (name = "") => {
  if (!name) return "";
  const trimmed = String(name).trim();
  const lower = trimmed.toLowerCase();
  const exts = [
    ".pdf",
    ".doc",
    ".docx",
    ".txt",
    ".zip",
    ".png",
    ".jpg",
    ".jpeg",
  ];
  for (const ext of exts) {
    if (lower.endsWith(ext)) {
      return trimmed.slice(0, -ext.length).trim();
    }
  }
  return trimmed;
};
